import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconTextStyleUnderline = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 12"
    aria-label="IconTextStyleUnderline"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M11.428 12H1.462v-1.412h9.966zM9.293 5.793a2.8 2.8 0 0 1-.407 1.319 2.86 2.86 0 0 1-3.68 1.082 2.63 2.63 0 0 1-1.61-2.482V0H2.175v5.8c.023.665.205 1.315.53 1.896a4.25 4.25 0 0 0 1.335 1.455 4.3 4.3 0 0 0 3.828.49A4.16 4.16 0 0 0 9.95 8.108c.512-.716.78-1.577.765-2.456V0H9.291z" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconTextStyleUnderline);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
